import styled, { createGlobalStyle } from 'styled-components';

export const Loading = styled.div`
	margin: 60px auto;
	font-size: 5px;
	position: relative;
	border: 3px solid #000;
	border-left: 3px solid #fff;
	transform: translateZ(0);
	animation: rgLoading 1.1s infinite linear;
	border-radius: 50%;
	width: 10em;
	height: 10em;
`;

export const ErrorIcon = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	font-size: 2rem;
	width: 70px;
	height: 70px;
	margin: 0.5em auto;
	border: 3px solid #1d1d1d;
	border-radius: 50%;
`;

export const GlobalStyle = createGlobalStyle`
	@keyframes rgLoading {
		0% {
			-webkit-transform: rotate(0deg);
			transform: rotate(0deg);
		}
		100% {
			-webkit-transform: rotate(360deg);
			transform: rotate(360deg);
		}
	}
`;
